import {Pipe, PipeTransform} from '@angular/core';
import {IncidentLocation} from "@services";

@Pipe({
    name: 'incidentLocation',
    standalone: true
})
export class IncidentLocationPipe implements PipeTransform {
    transform(value: IncidentLocation | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case IncidentLocation.TruckYard: return "Truck Yard";
            case IncidentLocation.ParkingLot: return "Parking Lot";
            case IncidentLocation.CoolerWarehouse: return "Cooler Warehouse";
            case IncidentLocation.AmbientWarehouse: return "Ambient Warehouse";
            case IncidentLocation.CoolerDockStaging: return "Cooler Dock / Staging";
            case IncidentLocation.AmbientDockStaging: return "Ambient Dock / Staging";
            case IncidentLocation.LayerPickLine: return "Layer Pick Line";
            case IncidentLocation.LooseCasePickLine: return "Loose Case Pick Line";
            case IncidentLocation.RadioShuttleRack: return "Radio Shuttle Rack";
            case IncidentLocation.MHEChargingArea: return "MHE Charging Area";
            case IncidentLocation.MHEMaintenanceArea: return "MHE Maintenance Area";
            case IncidentLocation.DockRollUpDoors: return "Dock / Roll Up Doors";
            default: return value;
        }
    }
}